import { CHANNEL } from 'src/data/channel';
import { INTEGRATION_CHANNELS, PERFORMANCE_CHANNELS, PLATFORM_CHANNELS, RESOURCES } from './const';

const DELIMITER = '__';

export const hashResource = ({ channel, id, name }) => [channel, id, name].join(DELIMITER);

export const isHashedResource = (value) => value?.includes(DELIMITER);

export const getChannelFromHashedResource = (value) =>
  isHashedResource(value) ? value.split(DELIMITER)[0] : value;
export const getAccountIdFromHashedResource = (value) => value.split(DELIMITER)[1];
export const getAccountUrlFromHashedResource = (value) => value.split(DELIMITER).slice(2).join();

export const isChannelSuggestedAnnotationsOrigin = (suggestedAnnotationsOrigin) =>
  PERFORMANCE_CHANNELS.includes(getChannelFromHashedResource(suggestedAnnotationsOrigin));

export const isResourceChannel = (channel) =>
  RESOURCES.includes(getChannelFromHashedResource(channel));

export const isIntegrationChannel = (channel) => INTEGRATION_CHANNELS.includes(channel);

export const isPlatformChannel = (channel) => PLATFORM_CHANNELS.includes(channel);

export const isFacebookChannel = (channel) =>
  [CHANNEL.facebook, CHANNEL.facebookPages].includes(channel);
